module.exports = __webpack_public_path__ + "img/hot-title.1c1b95f6.png";